import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/eyesecurity.webp';
import screenshot_target from '../../../images/letterfunnel/pietkerkhofs.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Piet Kerkhofs"
      firstname="Piet"
      companyname="Eye Security"
      competition="Northwave en Coalition"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/pietkerkhofs.js